import type { EventLoaderEvents } from '@otto-ec/global-resources/event-loader';
import type { TilelistTopics } from './Tilelist';

export type Topics = EventLoaderEvents & TilelistTopics;

/*                                                           */
/*                                                                                      */
export const eventQBus = window.o_global.eventQBus.with<Topics>();
